export default __webpack_public_path__ + "static/ritrutturazioni_-965c8856165c18629b52a7fc429a40c5.jpg";